import type { NavigateFunction, NavigateOptions } from 'react-router-dom';

class NavigationService {
  private navigate: NavigateFunction | null = null;

  setNavigate(navigate: NavigateFunction) {
    this.navigate = navigate;
  }

  navigateTo(path: string, options?: NavigateOptions) {
    if (this.navigate) {
      this.navigate(path, options);
    } else {
      console.warn('Navigation not initialized. Falling back to window.location');
      window.location.href = path;
    }
  }
}

export const navigationService = new NavigationService();
